import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { getDownloadURL, ref, listAll } from 'firebase/storage';
import { storage } from '../firebase/firebaseConfig';
import '../index.css';  // Archivo CSS para las animaciones

const VideoPlay = () => {
    const [videoUrls, setVideoUrls] = useState([]);  // Estado para almacenar las URLs de los videos
    const [currentVideoIndex, setCurrentVideoIndex] = useState(0);  // Estado para gestionar el video actual
    const [isFading, setIsFading] = useState(false);  // Estado para manejar la transición de desvanecimiento
    const [setLoading] = useState(true);  // Estado para manejar la carga

    // Función para obtener los videos desde Firebase Storage
    useEffect(() => {
      const fetchVideos = async () => {
        try {
          const listRef = ref(storage, 'videosfondocalocho/');
          const res = await listAll(listRef);
          const urls = await Promise.all(
            res.items.map(async (itemRef) => {
              const url = await getDownloadURL(itemRef);
              return url;
            })
          );
          setVideoUrls(urls);
        } catch (error) {
          console.error('Error obteniendo los videos:', error);
        } finally {
          setLoading(false);  // Finalizar la carga
        }
      };

      fetchVideos();
    }, []);

    // Función que maneja la transición al finalizar el video
    const handleVideoEnded = () => {
      setIsFading(true);  // Comenzar la animación de desvanecimiento
      setTimeout(() => {
        // Pasar al siguiente video después del desvanecimiento
        if (currentVideoIndex < videoUrls.length - 1) {
          setCurrentVideoIndex(currentVideoIndex + 1);  // Ir al siguiente video
        } else {
          setCurrentVideoIndex(0);  // Reiniciar la lista si es el último video
        }
        setIsFading(false);  // Comenzar la animación de aparición
      }, 500);  // Duración de la transición en milisegundos
    };

  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        zIndex: 1,
        overflow: 'hidden',
      }}
    >
      {videoUrls.length > 0 && (
        <video
          src={videoUrls[currentVideoIndex]}
          autoPlay
          muted
          onEnded={handleVideoEnded}
          className={`video ${isFading ? 'fade-out' : 'fade-in'}`}  // Clase CSS para la transición
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }}
        />
      )}
    </Box>
  );
}

export default VideoPlay;